import { useEffect, useState } from 'react'
import { Activity, AlertTriangle } from 'lucide-react'
import useUserStore from '../stores/userStore'
import useSipStore from '../stores/sipStore'

export default function UsageBadge() {
  const user = useUserStore(s => s.user)
  const apiBase = useSipStore(s => s.config.apiBase || 'https://agent.kailai.tech')
  const [usage, setUsage] = useState(null)
  const [err, setErr] = useState(null)

  useEffect(() => {
    if (!user?.agent_token) return
    let alive = true
    const load = async () => {
      try {
        const res = await fetch(`${apiBase}/api/v1/usage/current`, {
          headers: { 'X-Agent-Token': user.agent_token },
        })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const data = await res.json()
        if (alive) setUsage(data)
      } catch (e) {
        if (alive) setErr(e.message)
      }
    }
    load()
    const id = setInterval(load, 60_000)
    return () => { alive = false; clearInterval(id) }
  }, [user?.agent_token, apiBase])

  if (!user?.agent_token) return null
  if (!usage) return null

  const total = (usage.inbound_minutes || 0) + (usage.outbound_minutes || 0)
  const quota = usage.quota || {}
  const isUnlimited = quota.mode === 'unlimited'
  const isOver = quota.percent >= 100
  const isWarn = quota.percent >= 80

  return (
    <div className="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full bg-line/30 text-xs">
      {isOver ? <AlertTriangle size={12} className="text-rose-400" />
       : isWarn ? <AlertTriangle size={12} className="text-amber-400" />
       : <Activity size={12} className="text-emerald-400" />}
      <span className="ltr tech font-medium">{total} ד׳</span>
      {!isUnlimited && quota.quota && (
        <span className="text-mute ltr tech">/ {quota.quota}</span>
      )}
      {isUnlimited && <span className="text-mute text-[10px]">ללא הגבלה</span>}
    </div>
  )
}
